var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissionRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.527 31a.5.5 0 0 1-.497-.445A5.006 5.006 0 0 1 7 25c.711 0 1.405.149 2.045.438A3.505 3.505 0 0 1 12.5 22.5a.5.5 0 0 1 0 1A2.503 2.503 0 0 0 10 26c0 .039.006.076.012.112l.014.119a.499.499 0 0 1-.779.461A3.978 3.978 0 0 0 7 26a4.004 4.004 0 0 0-3.976 4.445.501.501 0 0 1-.497.555zM29.47 31a.5.5 0 0 1-.497-.561A3.504 3.504 0 0 0 25.5 26.5c-.595 0-1.177.16-1.728.476a.5.5 0 0 1-.654-.142A1.978 1.978 0 0 0 21.5 26a.5.5 0 0 1-.5-.5 3.016 3.016 0 0 0-1.716-2.712.499.499 0 1 1 .429-.903 4.026 4.026 0 0 1 2.261 3.154 3.025 3.025 0 0 1 1.675.876 4.375 4.375 0 0 1 1.852-.415 4.505 4.505 0 0 1 4.465 5.061.5.5 0 0 1-.496.439zM17.5 24a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5zM14.5 27a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.5.5zM21 30.999a.5.5 0 0 1-.5-.5c0-1.378-1.122-2.5-2.5-2.5-.967 0-1.856.572-2.265 1.458a.501.501 0 0 1-.81.141 1.986 1.986 0 0 0-1.425-.599c-.946 0-1.77.671-1.959 1.596a.5.5 0 1 1-.98-.2 3.01 3.01 0 0 1 2.939-2.396c.593 0 1.159.171 1.643.49A3.505 3.505 0 0 1 18 26.999c1.93 0 3.5 1.57 3.5 3.5a.5.5 0 0 1-.5.5z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 25.5,
    r: 0.5,
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 15.5-.5-1.8v3.991l-2 1v-3.034c0-.935.364-1.813 1.025-2.475l.696-.696c-.083-.408-.15-.814-.19-1.224l-1.213 1.213A4.47 4.47 0 0 0 10 15.657V19.5a.5.5 0 0 0 .724.447l3-1.5a.488.488 0 0 0 .227-.272C13.665 18.08 13.5 18 13.5 18zM20.682 12.475l-1.213-1.213c-.041.409-.107.816-.19 1.224l.696.696A3.477 3.477 0 0 1 21 15.657v3.034l-2-1V13.7l-.5 1.8V18s-.165.08-.45.175a.484.484 0 0 0 .227.272l3 1.5A.498.498 0 0 0 22 19.5v-3.843a4.47 4.47 0 0 0-1.318-3.182z",
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19c-1.6 0-2.678-.53-2.724-.553A.5.5 0 0 1 13 18v-2.432l-.589-2.121a12.64 12.64 0 0 1 3.236-12.301.5.5 0 0 1 .707 0 12.641 12.641 0 0 1 3.236 12.301L19 15.568V18a.5.5 0 0 1-.276.447C18.678 18.47 17.6 19 16 19zm-2-1.336c.37.133 1.086.336 2 .336.922 0 1.633-.202 2-.334V15.5c0-.045.006-.09.018-.134l.607-2.187A11.637 11.637 0 0 0 16 2.223a11.638 11.638 0 0 0-2.625 10.957l.607 2.187A.496.496 0 0 1 14 15.5z",
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 10.5,
    r: 0.5,
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 8.5,
    r: 0.5,
    fill: "#fff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16c-.187 0-.365-.007-.537-.02a.5.5 0 0 1 .073-.997c.149.011.303.017.464.017 1.366 0 2.268-.443 2.276-.447a.5.5 0 0 1 .447.895C18.678 15.47 17.6 16 16 16zM24.5 23a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.5.5zM26.5 19a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 1 0v7a.5.5 0 0 1-.5.5zM7.5 23a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.5.5zM5.5 18a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 1 0v6a.5.5 0 0 1-.5.5z",
    fill: "#ff6a00",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 19.5,
    r: 0.5,
    fill: "#fff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionRocket);
export default __webpack_public_path__ + "static/media/mission-rocket.2a3e5a860b898c29f83fec5f04c66ec5.svg";
export { ForwardRef as ReactComponent };